import React from 'react';

export const ProgressBar = ({
  stepFile,
  stepName,
  stepCategory,
  stepData,
  stepRenewal,
}: {
  stepFile: number,
  stepName: number,
  stepCategory: number,
  stepData: number,
  stepRenewal: number,
}) => {
  return (
    <div className="flex">
      <div className="progress-bar" style={{ backgroundColor: stepFile === 0 ? 'bg-doqit-primary' : 'white' }}></div>
      <div className="progress-bar" style={{ backgroundColor: stepName === 0 ? 'bg-doqit-primary' : 'white' }}></div>
      <div className="progress-bar" style={{ backgroundColor: stepCategory === 0 ? 'bg-doqit-primary' : 'white' }}></div>
      <div className="progress-bar" style={{ backgroundColor: stepData === 0 ? 'bg-doqit-primary' : 'white' }}></div>
      <div className="progress-bar" style={{ backgroundColor: stepRenewal === 0 ? 'bg-doqit-primary' : 'white' }}></div>
    </div>
  );
};

export default ProgressBar;
